import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onUnmounted } from "vue";
import { useStore } from "@/store";

type Color = [number, number, number];

const __default__ = {
  name: "Fluorescence",
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { runnerOutputs, registerOutput, UnregisterOutput } = useStore();

const outputNames = ["protein-GFP", "protein-mCherry"] as const;
for (const name of outputNames) {
  registerOutput(name);
}
onUnmounted(() => {
  for (const name of outputNames) {
    UnregisterOutput(name);
  }
});

const colors: { [key in typeof outputNames[number]]: Color } = {
  "protein-GFP": [0, 255, 0],
  "protein-mCherry": [255, 9, 91],
};
const lightRGBA = computed(() => {
  const color = [0, 0, 0];
  let sum = 0;
  let max = 0;
  for (const name of outputNames) {
    sum += runnerOutputs[name];
    max = Math.max(max, runnerOutputs[name]);
    for (let i = 0; i < 3; i++) {
      color[i] += colors[name][i] * runnerOutputs[name];
    }
  }
  if (sum > 0) {
    for (let i = 0; i < 3; i++) {
      color[i] /= sum;
    }
  }
  const opacity = max / (0.5 + max);
  return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${opacity})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "light",
    style: _normalizeStyle({ backgroundColor: _unref(lightRGBA) })
  }, null, 4))
}
}

})